<template>
<div class="chapter">
<div class="inner_page">
<span epub:type="pagebreak" id="page6" title="6">
<div class="toc-group">
<figure>
<img alt="" id="page006_001" src="images/page006_01.jpg"/>
</figure>
<p class="toc_1"><a href="#/html/page008"><span class="list_br1">Acknowledgments </span></a></p>
</div>
<div class="toc-group">
<figure>
<img alt="" id="page006_002" src="images/page006_02.jpg"/>
</figure>
<p class="toc_1"><a href="#/html/page009#recpage9"><span class="blueh">Introduction: Welcome to the Plant-Based Party </span></a></p>
</div>
<div class="toc-group">
<figure>
<img alt="" id="page006_003" src="images/page006_03.jpg"/>
</figure>
<p class="toc_1"><a href="#/html/page033#recpage33"><span class="blueh">Breakfast</span></a></p>
</div>
<div class="toc-group">
<figure>
<img alt="" id="page006_004" src="images/page006_04.jpg"/>
</figure>
<p class="toc_1"><span href="#/html/page073#recpage73" title="Link target outside of Sample"><span class="blueh">Bakery (Muffins, Biscuits, Breads, and More) </span></span></p>
</div>
<div class="toc-group">
<figure>
<img alt="" id="page006_005" src="images/page006_05.jpg"/>
</figure>
<p class="toc_1"><span href="#/html/page088#recpage88" title="Link target outside of Sample"><span class="blueh">Sandwiches </span></span></p>
</div>
<div class="toc-group">
<figure>
<img alt="" id="page006_006" src="images/page006_06.jpg"/>
</figure>
<p class="toc_1"><span href="#/html/page116#recpage116" title="Link target outside of Sample"><span class="blueh">Burgers </span></span></p>
</div>
<div class="toc-group">
<figure>
<img alt="" id="page006_007" src="images/page006_07.jpg"/>
</figure>
<p class="toc_1"><span href="#/html/page126#recpage126" title="Link target outside of Sample"><span class="blueh">Veggie Sides</span></span></p>
</div>
<div class="toc-group">
<figure>
<img alt="" id="page006_008" src="images/page006_08.jpg"/>
</figure>
<p class="toc_1"><span href="#/html/page143#recpage143" title="Link target outside of Sample"><span class="blueh">Cakes, Balls, and Fritters </span></span></p>
</div>
<div class="toc-group">
<figure>
<img alt="" id="page006_009" src="images/page006_09.jpg"/>
</figure>
<p class="toc_1"><span href="#/html/page152#recpage152" title="Link target outside of Sample"><span class="blueh">Salads </span></span></p>
</div>
<span epub:type="pagebreak" id="page7" title="7">
<div class="toc-group">
<figure>
<img alt="" id="page006_010" src="images/page006_10.jpg"/>
</figure>
<p class="toc_1"><span href="#/html/page184#recpage184" title="Link target outside of Sample"><span class="blueh">Bowls </span></span></p>
</div>
<div class="toc-group">
<figure>
<img alt="" id="page006_011" src="images/page006_11.jpg"/>
</figure>
<p class="toc_1"><span href="#/html/page195#recpage195" title="Link target outside of Sample"><span class="blueh">Appetizers, Sides, Snacks, and Party Platters </span></span></p>
</div>
<div class="toc-group">
<figure>
<img alt="" id="page006_012" src="images/page006_12.jpg"/>
</figure>
<p class="toc_1"><span href="#/html/page217#recpage217" title="Link target outside of Sample"><span class="blueh">Entrées </span></span></p>
</div>
<div class="toc-group">
<figure>
<img alt="" id="page006_013" src="images/page006_13.jpg"/>
</figure>
<p class="toc_1"><span href="#/html/page254#recpage254" title="Link target outside of Sample"><span class="blueh">Soups </span></span></p>
</div>
<div class="toc-group">
<figure>
<img alt="" id="page006_014" src="images/page006_14.jpg"/>
</figure>
<p class="toc_1"><span href="#/html/page273#recpage273" title="Link target outside of Sample"><span class="blueh">Desserts </span></span></p>
</div>
<div class="toc-group">
<figure>
<img alt="" id="page006_015" src="images/page006_15.jpg"/>
</figure>
<p class="toc_1"><span href="#/html/page324#recpage324" title="Link target outside of Sample"><span class="blueh">Drinks, Sips, and Smoothies </span></span></p>
</div>
<div class="toc-group">
<figure>
<img alt="" id="page006_016" src="images/page006_16.jpg"/>
</figure>
<p class="toc_1"><span href="#/html/page338#recpage338" title="Link target outside of Sample"><span class="blueh">For the Kids </span></span></p>
</div>
<div class="toc-group">
<figure>
<img alt="" id="page006_017" src="images/page006_17.jpg"/>
</figure>
<p class="toc_1"><span href="#/html/page345#recpage345" title="Link target outside of Sample"><span class="blueh">12 Happy Life Menus </span></span></p>
</div>
<div class="toc-group">
<p class="toc_1"><span href="#/html/index" title="Link target outside of Sample"><span class="list_br1">Index</span> </span></p>
</div>
</span></span>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// page006.vue?20ef98f4